import { TextField, EmailField, BooleanInput } from "react-admin";

import {
  AppList,
  AppListDefaultActions,
  AppListFilterCard,
  AppDatagrid,
  AppRowActions,
  SearchFilterInput,
  ListEditButton,
} from "@/adapters/inbound/layout";

export const PersonList = () => (
  <AppList perPage={25} sort={{ field: "displayName", order: "ASC" }}>
    <AppListDefaultActions />

    <AppListFilterCard
      search={<SearchFilterInput source="q" label="Suche" />}
      filters={
        <BooleanInput
          key="hasUser"
          source="hasUser"
          label="App-Zugang"
          helperText={false}
          parse={(value) => (value ? true : null)}
        />
      }
    />
    <AppDatagrid rowClick="show">
      <TextField source="displayName" label="Name" sortable />
      <TextField source="preferredName" label="Rufname" sortable={false} />
      <TextField source="mobilePhoneE164" label="Mobil" sortable={false} />
      <EmailField source="email" label="E-Mail" sortable={false} />
      <AppRowActions>
        <ListEditButton />
      </AppRowActions>
    </AppDatagrid>
  </AppList>
);
